<template>
  <div class="refund-item">
    <div class="fold-btn">
      <el-button size="mini" type="text" @click="fold=!fold">
        {{ fold ? '展开': '收起' }}
        <i v-if="fold" class="crm-icon-arrow-down" /><i v-else class="crm-icon-arrow-up" />
      </el-button>
    </div>
    <div class="row order-summary">
      <div class="col-sm-4">
        <label>退款单号</label>
        {{ refundOrder.refundSn }}
      </div>
      <div class="col-sm-5">
        <label>订单编号</label>
        <el-tooltip :content="`支付方式：${payTypes[refundOrder.payType]}`">
          <a :href="`/financeorder/${refundOrder.financeOrderSn}`">{{ refundOrder.orderSn }}<i class="crm-icon-arrow-right"></i></a>
        </el-tooltip>
      </div>
      <div class="col-sm-2">
        <label>卖家</label>
        {{ refundOrder.subSellerName }}
      </div>
      <div class="col-sm-2">
        <label>状态</label>
        {{ refundOrder.state | refundStateFmt }}
      </div>
      <div class="col-sm-3">
        <label>申请时间</label>
        {{ refundOrder.createTime | dateTimeFmt }}
      </div>
      <div class="col-sm-3">
        <label>退款时间</label>
        {{ refundOrder.timeReturn | dateTimeFmt }}
      </div>
      <div class="col-sm-2">
        <label>合计</label>
        {{ totalAmount }}
      </div>
      <div class="col-sm-3">
        <label>买家信息</label>
        <ellipsis-text :content="refundOrder.buyerName ">
          {{ refundOrder.buyerName }}
        </ellipsis-text>
      </div>
    </div>
    <div class="part-order-items" :class="{ fold: fold }">
      <div v-for="orderItem in refundOrder.refundItems" :key="orderItem.orderItemId" class="row part-order-item">
        <div class="info-item col-sm-8">
          <label>配件信息</label>
          <div>
            <div>
              <span>{{ orderItem.partName }}</span>
            </div>
            <div>
              <span style="padding-right: 4px">{{ orderItem.brandCode }}</span>
              <span v-if="orderItem.supersession">
                新件：{{ orderItem.supersession }}/旧件：
              </span>
              <span>{{ orderItem.partCode }}</span>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="info-item">
            <label>单价</label>
            <div>{{ orderItem.price }}</div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="info-item">
            <label>退款数量</label>
            <div>
              {{ orderItem.quantityReturn }}
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="info-item">
            <label>小计</label>
            <div>
              {{ (orderItem.quantityReturn * orderItem.price - orderItem.beanExchange * 1.00 / 100 - orderItem.couponAmount - orderItem.reductionAmount).toFixed(2) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RefundItem',
  filters: {
    refundStateFmt (val) {
      switch (val) {
        case -1: return '已取消'
        case 1: return '待确认'
        case 2: return '退款中'
        case 4: return '已退款'
        default: return '--'
      }
    }
  },
  props: {
    refundOrder: {
      type: Object,
      default () {
        return {
          id: undefined,
          refundSn: '',
          orderSn: '',
          buyerName: '',
          refundItems: []
        }
      }
    }
  },
  computed: {
    payTypes () {
      return this.$store.state.payTypes
    },
    totalAmount () {
      return this.refundOrder.refundItems.reduce((p, c) => p + c.quantityReturn * c.price - c.beanExchange * 1.00 / 100 - c.couponAmount - c.reductionAmount, 0).toFixed(2)
    }
  },
  data () {
    return {
      fold: true
    }
  }
}
</script>
